import { render } from "./AristocratView.vue?vue&type=template&id=0b82c2ef&scoped=true"
import script from "./AristocratView.vue?vue&type=script&lang=js"
export * from "./AristocratView.vue?vue&type=script&lang=js"

import "./AristocratView.vue?vue&type=style&index=0&id=0b82c2ef&scoped=true&lang=css"

import exportComponent from "D:\\Backup\\Sunville\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b82c2ef"]])

export default __exports__